import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { isMobile } from "react-device-detect";
import Spacebox from "../components/Spacebox";
import Grid from "../components/Grid";

const About = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    const abouts = [
        {
            image: '/svgs/badge.svg',
            heading: 'Excellence',
            content: 'We strive for excellence in every interaction, ensuring our clients receive the highest quality service and funding solutions.'
        },
        {
            image: '/svgs/established-businesses.svg',
            heading: 'Innovation',
            content: `Our innovative approach combines technology and expertise to deliver modern funding solutions for today's businesses.`
        },
        {
            image: '/svgs/partnership.svg',
            heading: 'Partnership',
            content: `We build lasting partnerships with our clients, supporting their growth journey every step of the way.`
        },

    ]


    const services = [
        {
            title: 'Personal Loans',
            desc: 'Fixed-amount lump sum loans typically based on your personal credit history, useful for consolidating debt or covering significant individual expenses.'
        },
        {
            title: 'Personal Credit Cards',
            desc: 'Revolving lines of credit for individual use that provide flexibility for daily purchases and help build a personal credit profile.'
        },
        {
            title: 'Business Loans',
            desc: 'Structured capital provided to a company for specific growth initiatives or operational costs, usually repaid with interest over a set term.'
        },
        {
            title: 'Business Credit Cards',
            desc: 'Revolving credit accounts issued to a business entity to manage short-term cash flow and track company expenditures separately from personal finances.'
        },
        {
            title: 'Business Lines of Credit',
            desc: 'A flexible funding arrangement that allows a business to draw funds as needed up to a certain limit, only paying interest on the amount actually used.'
        },
        {
            title: 'SBA Loan Programs',
            desc: 'Government-backed loans provided by the Small Business Administration that offer favorable terms and lower down payments for eligible small businesses.'
        },
        {
            title: 'Revenue-Based Financing',
            desc: 'A funding method where capital is provided in exchange for a percentage of ongoing gross revenues, often accessible even with lower credit scores.'
        },
        {
            title: 'Equity-Based Funding Solutions',
            desc: 'Raising capital by selling shares or ownership stakes in the business to investors, rather than taking on traditional debt.'
        },
        {
            title: 'Collateral-Backed Funding Options',
            desc: 'Loans secured by a business asset (such as equipment, real estate, or inventory), which can often lead to more competitive interest rates.'
        }
    ]

    return (
        <div className="about-page">
            <Header />
            <div>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '40px' : '60px' }}>
                            About Fund Genies
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ textAlign: 'center', color: '#000000', fontSize: isMobile ? '18px' : '20px' }}>
                            We're on a mission to revolutionize business funding <br /> by making it more
                            accessible, transparent, and tailored to your unique needs.
                        </Typography>
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </div>

            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <div>
                            <Typography variant="h3" style={{ textAlign: 'left', fontSize: isMobile ? '20px' : '25px' }}>
                                Our Core Philosophy
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .4, textAlign: 'left', fontSize: '18px' }}>
                                At Fund Genies, we believe that credit repair and funding are forms of
                                financial literacy—knowledge that should have been taught in school but often
                                wasn't. Our role is to educate, consult, and guide clients through the wide
                                range of funding options available, helping them understand how money, credit,
                                and leverage truly work so they can make informed decisions for themselves and
                                their businesses.
                                <br /><br />
                                <small><i>
                                    Fund Genies LLC is not a bank, lender, financial advisor, or loan
                                    officer. We do not make lending decisions or provide financial advice.
                                    We operate strictly as consultants and educators, guiding clients
                                    through funding strategies and available options based on their
                                    individual profiles and goals.
                                </i></small>
                            </Typography>
                        </div>
                        <Spacebox padding="20px" />
                        <Grid grid={isMobile ? 1 : 2} gap="20px" style={{ alignItems: 'center'}}>
                            {!isMobile && <Flexbox alignItems="center" justifyContent="center">
                                <img src="/assets/Sharkey.png" alt="sharkey" style={{ width: '400px' }} />
                            </Flexbox>}
                            <div>
                                <Typography style={{ opacity: .6, textAlign: 'left', fontSize: '20px' }}>
                                    Fund Genies LLC was established in 2024 by CEO Adermo Sharkey Elena, a
                                    seasoned entrepreneur with over 17 years of business experience. After years
                                    of building and operating businesses across multiple industries, Adermo founded
                                    Fund Genies with a clear purpose: to genuinely help individuals and business
                                    owners understand and access funding through education and strategy.
                                </Typography>
                            </div>
                        </Grid>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Our Mission
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            To take an educational-first approach to credit and funding—empowering our
                            clients with the financial knowledge and strategies we were never taught in
                            school, so they can build stability, growth, and long-term success.
                        </Typography>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>

            <section style={{ background: '#EDEDFD' }}>
                <Container>
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            What We Do
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            We specialize in consulting clients on a wide range of personal and business
                            funding solutions, including but not limited to:
                        </Typography>
                    </div>
                    <Spacebox padding="20px" />
                    <Grid grid={isMobile ? 1 : 3} gap="10px">
                        {services.map((service, index) => (
                            <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20', background: '#fff' }}>
                                <Flexbox alignItems="flex-start">
                                    <div>
                                        <Typography>
                                            <b>
                                                {service.title}
                                            </b>
                                        </Typography>
                                        <Spacebox padding="10px" />
                                        <span style={{ opacity: .6 }}>
                                            {service.desc}
                                        </span>
                                    </div>
                                </Flexbox>
                            </div>
                        ))}
                    </Grid>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .5, display: 'block', margin: 'auto', width: 'fit-content' }}>
                        Every client receives a customized funding strategy, not a one-size-fits-all approach.
                    </span>
                    <Spacebox padding="20px" />
                </Container>
            </section>
            <section>
                <Container>
                    <Spacebox padding="20px" />
                    <Spacebox padding="20px" />
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            A True One-Stop Funding Resource
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            Fund Genies operates as a one-stop shop for individuals, families, and
                            business owners seeking access to funding. Through our extensive network of
                            banks, lenders, and funding partners, we help guide clients toward options
                            that best align with their financial profile, goals, and timeline.
                        </Typography>
                    </div>
                    <Spacebox padding="40px" />
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Who We Serve
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            We work with:
                        </Typography>
                    </div>
                    <Spacebox padding="10px" />
                    <Grid grid={isMobile ? '1' : '4'} gap="10px">
                        {['Real estate investors and self-employed professionals', 'Entrepreneurs at every stage, from startup to scale', 'Business owners across all industries', 'Individuals seeking personal funding'].map((wws, index) => (
                            <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                <Flexbox alignItems="flex-start">
                                    <div>
                                        <span>
                                            {wws}
                                        </span>
                                    </div>
                                </Flexbox>
                            </div>
                        ))}
                    </Grid>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .5, display: 'block', margin: 'auto', width: 'fit-content' }}>
                        No matter where you are in your journey, we focus on education, preparation, and strategic positioning.
                    </span>
                    <Spacebox padding="20px" />
                </Container>
            </section>
            <section>
                <Container>
                    <Spacebox padding="40px" />
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Business Formation & Credit Profile Support
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            In addition to funding consultation, we also assist clients with foundational setup services, including:
                        </Typography>
                    </div>
                    <Spacebox padding="10px" />
                    <Grid grid={isMobile ? '1' : '4'} gap="10px">
                        {['Business formation and corporation setup', 'Structuring businesses properly for funding eligibility', 'Credit profile strengthening and optimization', 'Tradeline education and support to enhance credit profiles'].map((wws, index) => (
                            <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                <Flexbox alignItems="flex-start">
                                    <div>
                                        <span>
                                            {wws}
                                        </span>
                                    </div>
                                </Flexbox>
                            </div>
                        ))}
                    </Grid>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .5, display: 'block', margin: 'auto', width: 'fit-content' }}>
                        Our goal is to ensure clients are set up correctly from the start, so they are positioned for funding success both now and in the future.
                    </span>
                    <Spacebox padding="20px" />
                    <Spacebox padding="40px" />
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Built on Trust, Not Ads
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            Fund Genies LLC is a 100% referral-based business, built entirely through:
                        </Typography>
                    </div>
                    <Spacebox padding="10px" />
                    <Grid grid={isMobile ? '1' : '4'} gap="10px">
                        {['Word-of-mouth referrals', 'Organic relationships', 'Affiliate partnerships'].map((wws, index) => (
                            <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                <Flexbox alignItems="flex-start">
                                    <div>
                                        <span>
                                            {wws}
                                        </span>
                                    </div>
                                </Flexbox>
                            </div>
                        ))}
                    </Grid>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .5, display: 'block', margin: 'auto', width: 'fit-content' }}>
                        We do not rely on paid advertising. We believe that when you deliver real value and real results, your reputation becomes your marketing.
                    </span>
                    <Spacebox padding="20px" />
                    <Spacebox padding="40px" />
                    <div style={{ margin: 'auto', width: isMobile ? '100%' : '600px' }}>
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Our Commitment
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            We are committed to:
                        </Typography>
                    </div>
                    <Spacebox padding="10px" />
                    <Grid grid={isMobile ? '1' : '4'} gap="10px">
                        {['Transparency and honesty', 'Education before execution', 'Ethical consulting practices', 'Long-term client success over short-term wins'].map((wws, index) => (
                            <div key={index} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                <Flexbox alignItems="flex-start">
                                    <div>
                                        <span>
                                            {wws}
                                        </span>
                                    </div>
                                </Flexbox>
                            </div>
                        ))}
                    </Grid>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .5, display: 'block', margin: 'auto', width: 'fit-content' }}>
                        At Fund Genies, we don't just help you access funding—we help you understand it.
                    </span>
                    <Spacebox padding="20px" />
                </Container>
            </section>
            {/* WHY CHOOSE FUNDGENIES */}
            {false && <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Flexbox alignItems="center" justifyContent="center">
                            <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                <img src="/svgs/badge.svg" alt="badge" />
                            </Flexbox>
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Container>
                            <Typography variant="h4" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px' }}>
                                Why Choose Fund Genies ?
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                We combine cutting-edge technology with financial expertise to provide the <br />best funding solutions for your business
                            </Typography>
                            <Spacebox className="hide-in-mid-and-small" padding="20px" />
                            <Spacebox padding="40px" />
                            <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                                Ready to Get Started?
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                Take the first step towards securing the funding your business needs. <br />Our team is ready to help you explore your options.
                            </Typography>
                            <Spacebox padding="10px" />
                        </Container>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>}
            <Footer />
        </div>
    );
}

export default About;